import WOW from '../client-admin-app/wow.min'
import $ from "jquery";

let $offset = 120;
if ( $(window).width() < 768) {
    $offset = 70;
} else {
    $offset = 120;
}

$(window).resize(function() {
    if ( $(window).width() < 768) {
        $offset = 70;
    } else {
        $offset = 120;
    }
});

new WOW({
    offset: $offset
}).init();
